import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "loading flex middle-xs center-xs"
}
const _hoisted_2 = { class: "regular black fs-bigger" }

import { computed, ComputedRef, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { subscribe, isSupported } from 'on-screen-keyboard-detector';
import { Order } from '@/types';
import {
  BaseModalComponent,
  BaseModalHeaderComponent,
  BaseModalContentComponent,
  BaseModalFooterComponent,
} from '@/views/components/Base/BaseModal';
import ModalComponent from '@/views/components/ModalComponent.vue';
import ButtonComponent from '@/views/components/ButtonComponent.vue';
import SpinnerComponent from '@/views/components/SpinnerComponent.vue';
import SignInComponent from './SignInComponent.vue';
import SignUpComponent from './SignUpComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthModalComponent',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

const baseRef = ref<HTMLDivElement>(null);

const authDialogShown: ComputedRef<boolean> = computed(
  () => store.state.user.authDialogShown
);
const registerDialogShown: ComputedRef<boolean> = computed(
  () => store.state.user.registerDialogShown
);
const authLoading: ComputedRef<boolean> = computed(
  () => store.state.user.loading
);
const failureDialog: ComputedRef<Order.FailureDialog> = computed(
  () => store.state.user.failureDialog
);

function closeAuthModal() {
  store.commit('user/setRegisterDialogShown', false);
  store.commit('user/setAuthDialogShown', false);
}

function switchAuth() {
  if (authDialogShown.value) {
    store.commit('user/setAuthDialogShown', false);
    store.commit('user/setRegisterDialogShown', true);
  } else {
    store.commit('user/setAuthDialogShown', true);
    store.commit('user/setRegisterDialogShown', false);
  }
}

function showAuthFailure(show: boolean) {
  store.commit('user/showAuthFailure', show);
}

function detectMobileKeyboard() {
  const userAgent = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(userAgent) && isSupported()) {
    subscribe((visibility) => {
      if (
        visibility === 'visible' &&
        baseRef.value &&
        baseRef.value.contains(document.activeElement)
      ) {
        window.scrollTo(0, 0);
      }
    });
  }
}

onMounted(() => {
  detectMobileKeyboard();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "baseRef",
    ref: baseRef
  }, [
    _createVNode(ModalComponent, {
      class: "sign-in-modal",
      state: _unref(authDialogShown) || _unref(registerDialogShown),
      type: "prompt",
      onModalClose: _cache[1] || (_cache[1] = ($event: any) => (closeAuthModal())),
      "modal-name": "auth"
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(authDialogShown) ? _unref(t)('signIn') : _unref(t)('signUp')), 1)
      ]),
      headerBtn: _withCtx(() => [
        _createVNode(ButtonComponent, {
          class: "regular non-padding no-text-transform",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (switchAuth()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(registerDialogShown) ? _unref(t)('signIn') : _unref(t)('signUp')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_unref(authDialogShown))
          ? (_openBlock(), _createBlock(SignInComponent, { key: 0 }))
          : (_unref(registerDialogShown))
            ? (_openBlock(), _createBlock(SignUpComponent, { key: 1 }))
            : _createCommentVNode("", true),
        (_unref(authLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(SpinnerComponent, { width: 39 })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"]),
    _createVNode(_unref(BaseModalComponent), {
      isOpen: _unref(failureDialog).show
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseModalHeaderComponent), {
          onOnClose: _cache[2] || (_cache[2] = ($event: any) => (showAuthFailure(false)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(failureDialog).error), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseModalContentComponent), null, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(failureDialog).message), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseModalFooterComponent), null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(ButtonComponent, {
                fullWidth: "",
                class: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showAuthFailure(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('okBtn')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 512))
}
}

})